<template>
  <div class="channel-card">
    <div class="channel-card__inner">
      <div class="channel-card__inner__image">
        <span>{{ label }}</span>
      </div>
      <div class="channel-card__inner__info">
        <div class="current-episode">
          <div class="current-date">
            {{ currentEpisodeStarts }} -
            {{ currentEpisodeEnds }}
          </div>
          <router-link
            v-if="currentEpisodeUrl"
            :to="{ path: formatUrl(currentEpisodeUrl) }"
            class="current-name-link"
          >
            <div class="current-name">
              {{ currentEpisodeTitle }}
            </div>
          </router-link>
          <div v-else class="current-name">
            {{ currentEpisodeTitle }}
          </div>
          <div class="current-description" v-html="currentEpisodeDescription"/>
        </div>
        <div class="next-episode">
          <div class="next-episode__inner">
            <div class="next-episode__inner__date">
              NEXT EPISODE - {{ nextEpisodeStarts }} - {{ nextEpisodeEnds }}
            </div>
            <div class="next-episode__inner__name">
              {{ nextEpisodeTitle }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import logo from '@/assets/logos/stegi-radio-logo-black.svg';
import moment from "moment/moment";
import {extractCurrentEpisodeFromAirtimeResponse} from "@/store/storeHelper";

export default {
  name: "AppLiveStreamInfoCard",
  props: {
    channel: {
      type: Object,
      default: undefined,
      validator(value) {
        return typeof value === 'object' || value === undefined;
      },
    },
    label: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      currentEpisodeTitle: null,
      currentEpisodeUrl: null,
      currentEpisodeDescription: null,
      currentEpisodeImageUrl: null,
      currentEpisodeStarts: null,
      currentEpisodeEnds: null,
      nextEpisodeTitle: null,
      nextEpisodeStarts: null,
      nextEpisodeEnds: null
    }
  },
  computed: {
    imageUrl() {
      return this.currentEpisodeImageUrl !== null ? this.currentEpisodeUrl : logo;
    },
  },
  watch: {
    channel(value) {
      const {current, next} = value;
      if (current !== null) {
        this.currentEpisodeTitle = extractCurrentEpisodeFromAirtimeResponse(value, '');
        this.currentEpisodeUrl = current.url;
        this.currentEpisodeDescription = current.description;
        this.currentEpisodeStarts = this.formatDateToTime(current.starts);
        this.currentEpisodeEnds = this.formatDateToTime(current.ends);
      }
      if (next && next.length) {
        const nextFirst = next.shift();
        this.nextEpisodeTitle = nextFirst.name;
        this.nextEpisodeStarts = this.formatDateToTime(nextFirst.starts);
        this.nextEpisodeEnds = this.formatDateToTime(nextFirst.ends);
      }
    }
  },
  methods: {
    formatUrl(url) {
      const path = new URL(url);
      return path.pathname;
    },
    formatDateToTime(date) {
      return moment(date).format('HH:mm');
    },
  }
}
</script>


<style scoped lang="scss">
@import '@/assets/sass/abstracts/_variables.scss';

.channel-card {
  background-color: $c_stream_card_bg;
  width: 100%;
  @include media-breakpoint-up(xl) {
    width: 33.333333%;
  }

  &:not(:first-child) {
    @include media-breakpoint-up(xl) {
      border-left: 1px solid $c_white;
    }
  }

  &__inner {
    display: flex;
    flex-flow: column;
    height: 100%;
    @include media-breakpoint-up(xl) {
      flex-flow: row;
    }

    &__image {
      width: 100%;
      height: 100%;
      background: $c_data_bg-dark;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      aspect-ratio: 2/1;
      @include media-breakpoint-up(xl) {
        width: 40%;
        aspect-ratio: 1/1;
      }
      @include media-breakpoint-up(xxl) {
        width: 35%;
      }
      @include media-breakpoint-up(xxxl) {
        width: 30%;
      }
      span {
        color: $c_white;
        font-family: $font_medium;
        font-size: 80px;
      }
    }

    &__info {
      padding: 12px 24px 12px 8px;
      flex: 1;
      display: flex;
      flex-flow: column;
      justify-content: space-between;

      .current-date {
        @include font-12-md;
        margin-bottom: 3px;
        @include media-breakpoint-up(lg) {
          @include font-12-md;
        }
      }

      .current-name {
        @include font-18-md;
        margin-bottom: 10px;
        overflow-wrap: break-word;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        word-break: break-word;
        line-height: 1.2 !important;
        @include media-breakpoint-up(md) {
          @include font-14-md;
        }
        @include media-breakpoint-up(xl) {
          @include font-16-md;
        }
      }

      .current-name-link {
        color: $c_black;

        &:hover {
          color: $c_base;
        }
      }

      .current-description {
        overflow-wrap: break-word;
        @include font-12;
        line-height: 1.2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        margin-bottom: 10px;
      }

      .next-episode {
        &__inner {
          &__date {
            @include font-12-md;
          }

          &__name {
            @include font-12;
          }
        }
      }
    }
  }
}
</style>